import React from 'react';
import { Box, Typography, Fade, Paper, Button } from '@mui/material';
import { Chrome } from 'lucide-mui';
import { useTheme } from '@mui/material/styles';
import type { GlobalDialogProps } from '../../../../types';

// Reuse the same animation duration as in the parent component
const ANIMATION_DURATION = 400;

// Use the official onboarding URL
const CHROME_EXTENSION_URL =
  'https://screenapp.io/chrome?utm_source=onboarding';

interface ChromeExtensionScreenProps {
  onClose?: GlobalDialogProps['onClose'];
}

const ChromeExtensionScreen: React.FC<ChromeExtensionScreenProps> = () => {
  const handleInstallExtension = () => {
    window.open(CHROME_EXTENSION_URL, '_blank');
  };

  const theme = useTheme();

  return (
    <Fade in timeout={ANIMATION_DURATION}>
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          mb: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 300, mb: 2 }}>
          Install Chrome Extension
        </Typography>
        <Typography
          variant="subtitle1"
          color="text.secondary"
          sx={{ mb: 4, textAlign: 'center', maxWidth: '700px', mx: 'auto' }}
        >
          Our Chrome extension makes it easy to record your screen, browser
          tabs, and more
        </Typography>

        <Paper
          elevation={0}
          sx={{
            p: 4,
            maxWidth: '500px',
            width: '100%',
            bgcolor:
              theme.palette.mode === 'dark'
                ? 'background.paper'
                : theme.palette.grey[50],
            borderRadius: 4,
            textAlign: 'center',
          }}
        >
          <Chrome
            sx={{
              fontSize: 50,
              mb: 3,
              color: 'primary.main',
            }}
          />

          <Box
            sx={{
              p: 2,
              mb: 4,
              borderRadius: 1,
            }}
          >
            <Typography variant="body1">
              Record your screen, specific browser tabs, or application windows
              with a single click
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<Chrome />}
            onClick={handleInstallExtension}
            sx={{
              py: 1.5,
              px: 3,
              textTransform: 'none',
              fontSize: '1rem',
            }}
          >
            Add to Chrome
          </Button>
        </Paper>
      </Box>
    </Fade>
  );
};

export default ChromeExtensionScreen;
